const TRANSLATION_EVENT_NAME = 'pcportal:translation-event';

const emitTelemetryEvent = (eventPayload) => {
  try {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
      return;
    }

    const payload = {
      ...eventPayload,
      timestampMs: Date.now(),
    };

    window.dispatchEvent(new CustomEvent(TRANSLATION_EVENT_NAME, { detail: payload }));
  } catch (_) {
    // Best effort only.
  }
};

export const trackTranslationMiss = ({ key, language }) => {
  emitTelemetryEvent({
    type: 'translation_miss',
    key,
    language,
  });
};

export const trackTranslationRequestSuccess = ({
  key,
  language,
  source = 'runtime',
  latencyMs = 0,
}) => {
  emitTelemetryEvent({
    type: 'translation_request_success',
    key,
    language,
    source,
    latencyMs,
  });
};

export const trackTranslationRequestFailure = ({
  key,
  language,
  source = 'runtime',
  latencyMs = 0,
  errorMessage = '',
}) => {
  emitTelemetryEvent({
    type: 'translation_request_failure',
    key,
    language,
    source,
    latencyMs,
    errorMessage,
  });
};

export const TRANSLATION_TELEMETRY_EVENT = TRANSLATION_EVENT_NAME;
